import React from "react";
import { Box, Button, Typography} from "@material-ui/core";
import clsx from "clsx";
import { CloudUpload } from "@material-ui/icons";
import { useIntl } from "react-intl";
import { Grid, Hidden } from "@mui/material";
import { useStyles } from "./Document.styles";
import cloudImage from '../../../../Assets/Images/cloudImage.png'
export type FileUploadProps = {
  imageButton?: boolean;
  accept: string;
  hoverLabel?: string;
  dropLabel?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  borderStyle?: string;
  image?: {
    url: string;
    imageStyle?: {
      width?: string;
      height?: string;
    };
    marginTop5?:{
      marginTop:number;
    }
  };
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDrop: (event: React.DragEvent<HTMLElement>) => void;
};
export const FileUpload: React.FC<FileUploadProps> = ({
  accept,
  imageButton = true,
  hoverLabel = "document.upload.dragMessage",
  dropLabel = "document.upload.dropHere",
  width = "22.5rem",
 height = "5.5rem",
  backgroundColor = "inherit",
  borderStyle = "",
  image: {
    url = cloudImage,
    imageStyle = {
      height: 58,
      width:78
    },
  } = {},
  onChange,
  onDrop
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const [imageUrl, setImageUrl] = React.useState(url);
  const [labelText, setLabelText] = React.useState<string>(hoverLabel);
  const [isDragOver, setIsDragOver] = React.useState<boolean>(false);
  const [isMouseOver, setIsMouseOver] = React.useState<boolean>(false);
  const stopDefaults = (e: React.DragEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
  };
  const dragEvents = {
    onMouseEnter: () => {
      setIsMouseOver(true);
    },
    onMouseLeave: () => {
      setIsMouseOver(false);
    },
    onDragEnter: (e: React.DragEvent) => {
      stopDefaults(e);
      setIsDragOver(true);
      setLabelText(dropLabel);
    },
    onDragLeave: (e: React.DragEvent) => {
      stopDefaults(e);
      setIsDragOver(false);
      setLabelText(hoverLabel);
    },
    onDragOver: stopDefaults,
    onDrop: (e: React.DragEvent<HTMLElement>) => {
      stopDefaults(e);
      setLabelText(hoverLabel);
      setIsDragOver(false);
      if (imageButton && e?.dataTransfer?.files[0]) {
        setImageUrl(URL.createObjectURL(e?.dataTransfer?.files[0]));
      }
      onDrop(e);
    }
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (imageButton && event?.target?.files![0]) {
        setImageUrl(URL.createObjectURL(event?.target?.files![0]));
      }
    onChange(event);
  };
  return (
    <>
    <div className={classes.dargContainer}>
      <input
        onChange={handleChange}
        accept={accept}
        className={classes.hidden}
        id="file-upload"
        type="file"
      />
      <label
        htmlFor="file-upload"
        {...dragEvents}
        className={clsx(classes.root, isDragOver && classes.onDragOver)}
      >
        <Box
          width={width}
          height={height}
          bgcolor={backgroundColor}
          border={borderStyle}
          className={classes.noMouseEvent}
        >
          {imageButton && (
            <Box position="absolute" height={height} width={width}>
              <Grid  className={classes.dragsButton}>
                <Grid item >
                    <img alt = "" src={imageUrl} style={imageStyle} />
                </Grid>
                <Hidden only='xs'>
              <Grid item >
              <Typography className={classes.subHeading} variant="h4" align="center">
              {formatMessage({id:"document.upload.dragMessage",defaultMessage:"Click or drag to upload file"})}
             </Typography>
              </Grid>
                </Hidden>
                <Hidden smUp>
              <Grid item  >
              <Typography className={classes.subHeading} variant="h2" align="center">
              {formatMessage({id:"document.upload.dragMessage",defaultMessage:"Click or drag to upload file"})}
             </Typography>
              </Grid>
                </Hidden>
              </Grid>
            </Box>
          )}
        </Box>
      </label>
    </div>
    </>
  );
}